import { X } from 'lucide-react';
import type { FieldDef } from '@/lib/types';
import { formatValue } from '@/lib/format';

/** Seçili kaydın dikey görünümü (Delphi cxDBVerticalGrid detay paneli) */
export function RecordPanel({ row, fields, title, onClose }: { row: Record<string, any>; fields: FieldDef[]; title: string; onClose: () => void }) {
  const byField = new Map(fields.map((f) => [f.field.toLocaleUpperCase('tr-TR'), f]));
  return (
    <div className="panel flex w-80 shrink-0 flex-col rounded">
      <div className="flex items-center justify-between border-b b-border px-3 py-2">
        <span className="font-medium">{title} · Kayıt</span>
        <button onClick={onClose} className="rounded p-1 hover:bg-black/5"><X size={14} /></button>
      </div>
      <div className="min-h-0 flex-1 overflow-auto scroll-thin">
        <table className="w-full text-[12.5px]">
          <tbody>
            {Object.entries(row).map(([k, v]) => {
              const f = byField.get(k.toLocaleUpperCase('tr-TR'));
              if (f?.hidden) return null;
              return (
                <tr key={k} className="border-b b-border">
                  <td className="w-2/5 bg-[var(--grid-header)] px-2 py-1 align-top muted">{f?.caption ?? k}</td>
                  <td className="whitespace-pre-wrap break-words px-2 py-1">{formatValue(v, undefined, f?.mask)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
